module.exports = __webpack_public_path__ + "static/media/canceled.798317c2.svg";